import { authMiddleware } from "~/components/_refactored/auth";

export default authMiddleware;
